import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";

Turbolinks.start();
ActiveStorage.start();
if(!window._rails_loaded) {
  Rails.start();
}

import "bootstrap/dist/js/bootstrap"
import "./google-maps-api"
import "./theme/theme"
import "./search_form_autocomplete"
import "./alert"
import "./validation"
import "./magnific-popup"

import "cocoon-js"
import "./../controllers"

import "@fortawesome/fontawesome-free/js/all";

// needed to use jquery in the rails ujs responses
import $ from 'jquery'

window.$ = $;

import "./cookies_banner"
